import { BCMSRecord, Workflow, useBCMSContext } from "@bcm-dev/bcms-vite";
import StopPaymentConfirmPage from "components/pages/StopPaymentConfirmPage";
import StopPaymentPage from "components/pages/StopPaymentPage";
import Classes from "model";
import React from "react";
import StopPayment from "./classes/StopPayment";

const steps = [ StopPaymentPage, StopPaymentConfirmPage];

/**
 * @function StopPaymentsWorkflow
 * @returns {React.Component}
 * @description The main workflow component for the Stop payments work flow
 * @exported true
 * @example
 * <StopPaymentsWorkflow />
 */
export default function StopPaymentsWorkflow(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const value = getDefaultStopPayment(globalController);
    return <Workflow value={ value } steps={ steps } />
}
/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @description Hook to return the steps of the workflow
 * @exported true
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefaultStopPayment
 * @returns {OBJECT}
 * @description Return am object with all the info required for the workflow
 * @exported true
 */
export const getDefaultStopPayment = (controller) => {
    const { branding } = controller.state;
    const { options } = branding;
    let showConfirmationCheckbox = options.stoppayment_checkbox_abi22;
    showConfirmationCheckbox = showConfirmationCheckbox === "true";

    // fields as an array of objects
    const stopCheckCustomFields = StopPayment.getArrayOfCustomFieldObjectsByBrandingOptionType(branding, `stop_check_field`);
    const stopRangeCustomFields = StopPayment.getArrayOfCustomFieldObjectsByBrandingOptionType(branding, `stop_range_field`);
    const payment = StopPayment.init({ stopCheckCustomFields, stopRangeCustomFields, hasStopPaymentFee: showConfirmationCheckbox });
    
    return {
      data: {
        payment: payment,
      },
      ui: {}
    }
};